//#region src/loves_concept.ts
let LovesConcept = /* @__PURE__ */ function(LovesConcept) {
	LovesConcept["ExpressCheckout"] = "express-checkout";
	LovesConcept["Subway"] = "subway";
	return LovesConcept;
}({});
//#endregion
export { LovesConcept };

//# sourceMappingURL=loves_concept.js.map